<template>
  <div
    v-if="questionGroup"
    class="flex slider-question align-item-start w-full"
  >
    <img
      v-if="questionGroup.image"
      class="slider-question__image"
      :src="`${imageUrl}/${questionGroup.image}`"
      alt="Картинка"
    />
    <div class="w-full slider-question__question">
      <p class="slider-question__description">{{ questionGroup.text }}</p>
      <div v-if="questionGroup.questions">
        <div
          v-for="question in questionGroup.questions"
          :key="question.id"
          class="slider-question__answer align-item-center"
        >
          <p v-if="question.text" class="slider-question__text">
            {{ question.text }}
          </p>
          <div class="slider-question__slider slider flex w-full">
            <div
              v-for="(answer, index) in question.answers"
              :key="answer.id"
              class="slider__radio-wrap flex flex-column"
            >
              <label :for="`answer_${question.id}_${answer.id}`">
                <div v-if="!answer.text && index === 0">Низкая степень</div>
                <div
                  v-if="isEmotion && winWidth > 1050 && index > 0 && index < 4"
                ></div>
                <div v-else>{{ answer.text }}</div>
                <div
                  v-if="!answer.text && index === question.answers.length - 1"
                >
                  Высокая степень
                </div>
              </label>
              <input
                :id="`answer_${question.id}_${answer.id}`"
                :name="`answer_${question.id}`"
                type="radio"
                @change="setAnswer"
                :value="answer.value"
                :data-answer="answer.id"
                :data-question="question.id"
                :checked="savedAnswersMap[question.id] === answer.id"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, onBeforeMount, toRef, watch } from "@vue/runtime-core";
import { useStore } from "vuex";
import useAnswers from "@/mixins/useAnswers";

export default {
  name: "table-question-group",
  props: {
    questionGroup: {
      type: Object,
    },
    missedGroup: {
      type: Number,
      default: 0,
    },
    savedAnswers: {
      type: Array,
      default: () => [],
    }
  },
  inject: ["imageUrl"],
  setup(props, context) {
    const group = toRef(props, "questionGroup");
    const missedGroup = toRef(props, "missedGroup");
    const { setAnswer, clearAnswers } = useAnswers(context);

    const store = useStore();
    const winWidth = computed(() => store.state.width);
    // Проверка на то что вопрос - шкала
    const isEmotion = computed(
      () => group.value.questions[0].answers[1].text == "Слабо"
    );

    const savedAnswersMap = computed(() => {
      const map = {};

      for (const item of props.savedAnswers) {
        map[item.question_id] = item.question_answer_id;
      }

      return map;
    });

    onBeforeMount(() => {
      // Если это один из вопросов с незаполненными ответами - дополняем тремя промежуточными значениями
      group.value.questions.forEach((question) => {
        if (question.answers.length === 5 && question.answers[1].text === "") {
          question.answers[1].text = "";
          question.answers[2].text = "";
          question.answers[3].text = "";
        }
      });
    });

    watch(group, () => {
      clearAnswers();
    });

    watch(missedGroup, () => {
      if (missedGroup.value === group.value.id) {
        clearAnswers();
      }
    });

    return {
      isEmotion,
      winWidth,
      group,
      setAnswer,
      savedAnswersMap
    };
  },
};
</script>

<style lang="scss" scoped>
.slider-question {
  column-gap: 20px;

  &__question {
    max-width: 800px;
  }

  &__image {
    display: block;
    max-width: 40%;
    max-height: 500px;
    margin-bottom: 15px;
    -o-object-fit: contain;
    object-fit: contain;
    object-position: center;
    border-radius: 8px;
  }

  &__answer {
    padding: 16px;
    width: 100%;
    border-radius: 10px;
    margin-top: 20px;
    background-color: var(--light-grey);

    p {
      padding-right: 20px;
      flex: 0 1 30%;
    }
  }

  &__description {
    font-size: 16px;
    font-weight: 500;
    text-align: left;
  }

  &__text {
    padding: 0;
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 8px;
  }

  @media (max-width: 1050px) {
    flex-direction: column;

    &__image {
      margin-right: auto;
      max-width: 600px;
    }
  }

  @media (max-width: $mobile-breakpoint) {
    &__answer {
      flex-direction: column;
    }

    &__slider {
      flex-direction: column;
      margin-top: 8px;
      row-gap: 12px;
    }

    &__image {
      max-width: 90%;
    }
    &__description {
      font-size: 16px;
    }
  }
}


.slider {
  &__radio-wrap {
    flex: 1;
    position: relative;

    label {
      margin: 0 auto 5px;
      display: block;
      width: max-content;
      padding: 0;
      text-align: center;
      flex: 1 0 auto;
      word-break: break-word;
      word-break: keep-all;
      font-size: 14px;

      &::after {
        content: "";
        position: absolute;
        left: -20px;
        right: -20px;
        bottom: -10px;
        height: 30px;
        cursor: pointer;
      }
    }

    &:not(:last-child)::before {
      content: "";
      position: absolute;
      height: 3px;
      width: 50%;
      display: block;
      background-color: var(--cream-color);
      bottom: 6px;
      left: 50%;
    }

    &:not(:first-child)::after {
      content: "";
      position: absolute;
      height: 3px;
      width: 50%;
      display: block;
      background-color: var(--cream-color);
      bottom: 6px;
      right: 50%;
    }

    &:first-child::before {
      width: 100%;
      left: 0;
    }

    &:last-child::after {
      width: 100%;
      right: 0;
    }

    &:first-child {
      label {
        margin: 0 auto 5px 0;
      }

      input {
        margin: 0 auto 0 0;
      }
    }

    &:last-child {
      input {
        margin: 0 0 0 auto;
      }

      label {
        margin: 0 0 5px auto;
      }
    }

    input {
      width: 16px;
      height: 16px;
      display: block;
      background-color: #fff;
      border: 1px solid var(--cream-color);
      border-radius: 50%;
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      cursor: pointer;
      margin: auto;
      position: relative;
      z-index: 2;
    }

    input:hover,
    input:focus {
      border-color: var(--main-green) !important;
    }

    input:checked {
      background-color: #fff !important;
      border: 1px solid var(--main-green) !important;
    }

    input:checked::after {
      content: "";
      position: absolute;
      top: 50%;
      left: 50%;
      width: 8px;
      height: 8px;
      transform: translate(-50%, -50%);
      background: var(--main-green);
      border-radius: 50%;
    }

    @media (max-width: $mobile-breakpoint) {
      label {
        margin-bottom: 0;
      }

      &:first-child {
        label {
          margin-bottom: 0;
        }
      }

      &:last-child {
        label {
          margin-bottom: 0;
        }
      }

      align-items: center;
      column-gap: 8px;
      padding: 0;
    }
  }

  @media (max-width: 1420px) {
    label {
      font-size: 16px;
    }
  }

  @media (max-width: $mobile-breakpoint) {
    &__radio-wrap {
      flex-direction: row-reverse;

      &::before,
      &::after {
        display: none;
        opacity: 0;
      }
    }

    label {
      font-size: 16px;
      text-align: left;
      padding-bottom: 0;
    }
  }
}
</style>